/* @flow */

import _ from 'lodash';

export const getLevelById = ({ levels }: Object, level_id: string) => (_.find(levels, { id: level_id }) || {});
